// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.l8hJyaPvo9smd6LiNqWK {
  color: var(--text-light);
  list-style: none;
  padding: 0;
  font-size: 3vmin;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-top: -1vmin;
  margin-bottom: 0.8vmin;
}

.l8hJyaPvo9smd6LiNqWK li {
  padding: 0.6vmin;
  text-align: center;
  border-radius: 0.5vmin;
  margin-bottom: 0.5vmin;
  transition: transform 0.3s ease;
}

.l8hJyaPvo9smd6LiNqWK li:hover:not(._scckhAN2KPE1u73kR14) {
  cursor: pointer;
  transform: scale(1.1);
  color: var(--blue-1);
}

.l8hJyaPvo9smd6LiNqWK li._scckhAN2KPE1u73kR14 {
  color: var(--green-yellow);
  font-weight: 700;
  font-size: 1.05em;
  background-color: var(--bg);
}`, "",{"version":3,"sources":["webpack://./src/components/CategoryList/CategoryList.module.scss"],"names":[],"mappings":"AAAA;EACI,wBAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,+BAAA;AACJ;;AAEA;EACI,eAAA;EACA,qBAAA;EACA,oBAAA;AACJ;;AAEA;EACI,0BAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;AACJ","sourcesContent":[".CategoryList {\n    color: var(--text-light);\n    list-style: none;\n    padding: 0;\n    font-size: 3vmin;\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n    margin-top: -1vmin;\n    margin-bottom: .8vmin;\n}\n\n.CategoryList li {\n    padding: .6vmin;\n    text-align: center;\n    border-radius: .5vmin;\n    margin-bottom: .5vmin;\n    transition: transform 0.3s ease;\n}\n\n.CategoryList li:hover:not(.active) {\n    cursor: pointer;\n    transform: scale(1.1);\n    color: var(--blue-1);\n}\n\n.CategoryList li.active {\n    color: var(--green-yellow);\n    font-weight: 700;\n    font-size: 1.05em;\n    background-color: var(--bg);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"CategoryList": `l8hJyaPvo9smd6LiNqWK`,
	"active": `_scckhAN2KPE1u73kR14`
};
export default ___CSS_LOADER_EXPORT___;
